export const MONTHS = [
  { v: 1, l: "Januari" }, { v: 2, l: "Februari" }, { v: 3, l: "Maret" },
  { v: 4, l: "April" }, { v: 5, l: "Mei" }, { v: 6, l: "Juni" },
  { v: 7, l: "Juli" }, { v: 8, l: "Agustus" }, { v: 9, l: "September" },
  { v: 10, l: "Oktober" }, { v: 11, l: "November" }, { v: 12, l: "Desember" },
];

export const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
export const YEARS = [2024, 2025, 2026, 2027];

export const SAFETY_CATEGORIES = [
  "Unsafe Condition", "Unsafe Action", "CAR-IN 01 Working at Height",
  "CAR-IN 02 Automotive Vehicle", "CAR-IN 03 Mobile Equipment",
  "CAR-IN 04 Isolation And Lockout", "CAR-IN 05 Lifting Of Loads",
  "CAR-IN 06 Confined Space", "CAR-IN 07 Rotating Equipment",
  "CAR-IN 08 Slope Stability", "CAR-IN 10 Electrical",
  "CAR-IN 15 Road Condition and Traffict Management",
  "CAR-IN 17 Dangerous Goods & Hazardous Chemical", "CAR-IN 18 Tyres and Rims",
];

export const AREAS_5S = [
  "Main Office", "Workshop Level I", "Batch Plant", "Level III Tertiary Crusher",
  "Level IV Tertiary Crusher", "Cone Crusher", "Jaw Crusher", "Shelter B3 Level III",
  "Level II Tertiary Crusher", "Steel Yard", "Fuel Storage", "Tertiary Crusher",
];

export const PRIORITIES = ["Low", "Medium", "High", "Urgent"];
export const STATUSES = ["Complete", "In Progress", "Waiting Part", "No Progress"];
export const INCIDENT_TYPES = ["Personal Incident", "Vehicle Incident", "Property Damage", "First Aid Case", "Near Miss"];
export const SEVERITIES = ["Low", "Medium", "High"];

export const CHART_COLORS = ["#2563eb", "#16a34a", "#f59e0b", "#dc2626", "#7c3aed", "#0891b2", "#db2777", "#65a30d", "#ea580c", "#4f46e5", "#059669", "#9333ea", "#e11d48", "#0d9488"];

export function priorityClass(p) {
  switch (p) {
    case "Low": return "bg-green-100 text-green-700";
    case "Medium": case "Med": return "bg-yellow-100 text-yellow-700";
    case "High": return "bg-red-100 text-red-600";
    case "Urgent": return "bg-red-700 text-white";
    default: return "bg-slate-100 text-slate-600";
  }
}

export function statusClass(s) {
  switch (s) {
    case "Complete": return "text-green-600";
    case "In Progress": return "text-yellow-600";
    case "Waiting Part": return "text-blue-600";
    case "No Progress": return "text-red-500";
    default: return "text-slate-600";
  }
}

export function statusHex(s) {
  switch (s) {
    case "Complete": return "#16a34a";
    case "In Progress": return "#f59e0b";
    case "Waiting Part": return "#2563eb";
    case "No Progress": return "#dc2626";
    default: return "#94a3b8";
  }
}

export function expiryStatusClass(s) {
  switch (s) {
    case "Active": return "bg-green-100 text-green-700";
    case "Hampir Expired": return "bg-yellow-100 text-yellow-700";
    case "Expired": return "bg-red-100 text-red-600";
    default: return "bg-slate-100 text-slate-600";
  }
}

export function formatDateID(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()].l} ${d.getFullYear()}`;
}

export function weekOfYear(date) {
  const y = date.getFullYear();
  const jan1 = new Date(y, 0, 1);
  const daysToSat = (6 - jan1.getDay() + 7) % 7;
  const firstSat = new Date(y, 0, 1 + daysToSat);
  if (date < firstSat) return 1;
  return 2 + Math.floor((date - firstSat) / (7 * 86400000));
}

export function weeksInMonth(year, month) {
  const set = new Set();
  const days = new Date(year, month, 0).getDate();
  for (let d = 1; d <= days; d++) set.add(weekOfYear(new Date(year, month - 1, d)));
  return [...set].sort((a, b) => a - b);
}

export const ABSENSI_STATUS = ["Hadir", "Absen", "Ijin", "Sakit", "Cuti"];
export function absensiHex(s) {
  return { Hadir: "#16a34a", Absen: "#dc2626", Sakit: "#2563eb", Ijin: "#f59e0b", Cuti: "#9333ea" }[s] || "#94a3b8";
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

